import React from "react";
import {
  useWSModalCustom,
  WSInfoBox,
  WSList,
  WSModal,
  WSModalCustomProps,
  WSText
} from "@wingspanhq/fe-component-library";

const ModalWhatIsQLE: React.FC<WSModalCustomProps<void>> = ({ onClose }) => (
  <WSModal
    title="What is a QLE?"
    size="M"
    onClose={onClose}
    actions={{
      alignment: "fill",
      buttons: [
        {
          label: "Done",
          kind: "Primary",
          onClick: () => onClose()
        }
      ]
    }}
  >
    <WSInfoBox>
      <WSList gap="L">
        <WSText weight="medium" color="gray700">
          Qualifying Life Events (QLEs)
        </WSText>
        <WSText.ParagraphSm color="gray700">
          Once enrolled, your coverage is locked for the plan year. You can only
          make changes if you experience a Qualifying Life Event:
        </WSText.ParagraphSm>

        <WSList gap="XS">
          <WSText.ParagraphSm weight="medium" color="gray700">
            Family Changes:
          </WSText.ParagraphSm>
          <ul>
            <li>Marriage or divorce</li>
            <li>Birth, adoption, or foster placement of a child</li>
            <li>Death of a covered dependent</li>
          </ul>
        </WSList>

        <WSList gap="XS">
          <WSText.ParagraphSm weight="medium" color="gray700">
            Coverage Changes:
          </WSText.ParagraphSm>
          <ul>
            <li>
              Loss of other health insurance (spouse's plan, parent's plan,
              etc.)
            </li>
            <li>Turning 26 and losing eligibility on a parent's plan</li>
            <li>Change in work status affecting coverage eligibility</li>
          </ul>
        </WSList>

        <WSList gap="XS">
          <WSText.ParagraphSm weight="medium" color="gray700">
            To request a change:
          </WSText.ParagraphSm>
          <ul>
            <li>Contact Meridio within 60 days of the event</li>
            <li>
              Provide documentation (marriage certificate, birth certificate,
              etc.)
            </li>
            <li>Meridio will verify and process your request</li>
          </ul>
        </WSList>

        <WSText.ParagraphSm color="gray700">
          <b>Questions?</b> Call Meridio at (855) 697-0007
        </WSText.ParagraphSm>
      </WSList>
    </WSInfoBox>
  </WSModal>
);

export const useModalWhatIsQLE = () => useWSModalCustom(ModalWhatIsQLE);
